import type {
  TagGroupResponse,
  TagResponse,
} from "@redotech/effect-api-shared/rpc/tag";
import {
  supportTicketQueryScopeKey,
  type SupportTicketQueryScope,
} from "./support-ticket-query-keys";

const SUPPORT_TICKET_TAG_QUERY_KEY_ROOT = ["supportTicketTags"] as const;

export type SupportTicketTagQueryScope = SupportTicketQueryScope;

type SupportTicketTagScopeKey =
  | readonly ["account", string]
  | readonly ["team", string]
  | readonly ["unscoped"];

export function supportTicketTagScopeKey(
  scope?: SupportTicketTagQueryScope,
): SupportTicketTagScopeKey {
  return supportTicketQueryScopeKey(scope);
}

export const supportTicketTagQueryKeys = {
  all: SUPPORT_TICKET_TAG_QUERY_KEY_ROOT,
  accountTags: (scope?: SupportTicketTagQueryScope) =>
    [
      ...SUPPORT_TICKET_TAG_QUERY_KEY_ROOT,
      "accountTags",
      ...supportTicketTagScopeKey(scope),
    ] as const,
};

export interface AccountTagsResponse {
  tags: readonly TagResponse[];
  tagGroups: readonly TagGroupResponse[];
}
